import { gql } from '@apollo/client';

export const UPDATE_USER_ROLE = gql`
  mutation UpdateUserRole($request: UpdateUserRoleRequest!) {
    UpdateUserRole(request: $request) {
      id
    }
  }
`;

export const CREATE_USER_ROLE = gql`
  mutation CreateUserRole($request: CreateUserRoleRequest!) {
    CreateUserRole(request: $request) {
      id
    }
  }
`;
